import { render } from "./Video.vue?vue&type=template&id=a72ba01a"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/video/Video.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a72ba01a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a72ba01a', __exports__)) {
    api.reload('a72ba01a', __exports__)
  }
  
  module.hot.accept("./Video.vue?vue&type=template&id=a72ba01a", () => {
    api.rerender('a72ba01a', render)
  })

}


export default __exports__